/* tslint:disable:jsx-no-lambda WI:47781 */
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { getRTL } from 'office-ui-fabric-react/lib/Utilities';
import { twistyButtonExpandConversationLabel } from './MailListItemTwistyButton.locstring.json';

const styles = require('./MailListItemTwistyButton.scss');
const classNames = require('classnames');

export interface MailListItemTwistyButtonProps {
    isExpanded: boolean;
    onClick: (evt: React.MouseEvent<unknown>) => void;
    className?: string;
}

function MailListItemTwistyButton(props: MailListItemTwistyButtonProps) {
    const twistyImageClassNames = classNames(
        styles.twistyImage,
        props.isExpanded && (getRTL() ? styles.expandedrtl : styles.expandedltr)
    );

    return (
        <IconButton
            aria-expanded={props.isExpanded}
            aria-label={twistyButtonExpandConversationLabel}
            className={classNames(props.className, styles.button, 'flipForRtl')}
            iconProps={{
                iconName: ControlIcons.ChevronRightMed,
                styles: {
                    root: twistyImageClassNames,
                },
            }}
            tabIndex={-1}
            onClick={props.onClick}
            onDoubleClick={(evt: React.MouseEvent<unknown>) => {
                evt.stopPropagation();
            }}
        />
    );
}
export default MailListItemTwistyButton;
